import { HttpClient } from '@angular/common/http';
import { TranslatePipe } from '@ngx-translate/core';
import { Component, OnInit } from '@angular/core';
import { DynamicFieldConfig } from '../../../../core/shared/dynamic-form/form-config.model';
import { TableColumn } from '../../../shared/models/table-models';
import { Setup } from '../../shared/service/setup';
import { CommonModule } from '@angular/common';
import { Table } from "../../../shared/table/table";
import { Popup } from "../../../../core/shared/components/popup/popup";

@Component({
  selector: 'app-kibor-quarterly',
  imports: [TranslatePipe, CommonModule, Table, Popup],
  templateUrl: './kibor-quarterly.html',
  styleUrl: './kibor-quarterly.css',
})
export class KiborQuarterly implements OnInit {

  showPopup = false;

popupFields: DynamicFieldConfig[] = [
  {
    key: 'kbrRate',
    label: 'SETUP.KIBOR.RATE_PERCENT',
    type: 'number',
    validations: { required: true, min: 0.01 }
  },
  {
    key: 'strtdt',
    label: 'SETUP.KIBOR.EFFECTIVE_START_DATE',
    type: 'date',
    validations: { required: true }
  },
  {
    key: 'enddt',
    label: 'SETUP.KIBOR.EFFECTIVE_END_DATE',
    type: 'date',
    validations: { required: true }
  }
];
openPopup(): void {
  this.showPopup = true;
}


  // ================= CURRENT KIBOR =================
  currentKiborRate = '';
  currentStartDate = '';
  currentEndDate = '';

  // ================= TABLE CONFIG =================
columns: TableColumn[] = [
  { key: 'sr', label: 'SETUP.KIBOR.SR' },
  { key: 'rate', label: 'SETUP.KIBOR.RATE_PERCENT' },
  { key: 'strtdt', label: 'SETUP.KIBOR.EFFECTIVE_START_DATE' },
  { key: 'enddt', label: 'SETUP.KIBOR.EFFECTIVE_END_DATE' }
];


  data: any[] = [];

  constructor(private setupService: Setup, private http: HttpClient) { }

ngOnInit(): void {
  this.loadCurrentKibor();
  this.loadKiborList();
}

formatDateLocal(dateStr: string): string {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

loadCurrentKibor(): void {
  this.setupService.getCurrentKibor(20 ).subscribe({
    next: (res: any) => {
       if (!res) return;
      this.currentKiborRate = res.kbrRate != null ? `${res.kbrRate}%` : '';
      this.currentStartDate = this.formatDateLocal(res.strtDt);
      this.currentEndDate = this.formatDateLocal(res.endDt);
    },
    error: () => {
      this.currentKiborRate = '';
      this.currentStartDate = '';
      this.currentEndDate = '';
    }
  });
}

loadKiborList(): void {
  this.setupService.getKiborHistory(20 ).subscribe({
    next: (res: any) => {
      const list = Array.isArray(res) ? res : res.data || res.list || [];

      // 🔽 Sort by created date DESC (latest first)
      const sorted = [...list].sort(
        (a, b) => new Date(b.crtdAt).getTime() - new Date(a.crtdAt).getTime()
      );

      this.data = sorted.map((item, index) => ({
      sr: index + 1,
      rate: item.kbrRate.toFixed(2),
      strtdt: this.formatDateLocal(item.strtDt),
      enddt: this.formatDateLocal(item.endDt)
    }));
    },
    error: (err) => {
      console.error('Failed to load KIBOR list', err);
    }
  });
}

  // ================= SAVE KIBOR =================
 handleSave(formData: any): void {
  const toUtcMidnight = (dateStr: string) => {
    const [year, month, day] = dateStr.split('-').map(Number);
    const utcDate = new Date(Date.UTC(year, month - 1, day, 0, 0, 0));
    return utcDate.toISOString();
  };
  const payload = {
    kbrSeq: 0,
    kbrRate: Number(formData.kbrRate),
    strtDt: toUtcMidnight(formData.strtdt),
    endDt: toUtcMidnight(formData.enddt),
    typ: 20  ,
    delFlg: 0
  };

  console.log('POST PAYLOAD:', payload);

  this.setupService.saveKibor(payload).subscribe({
    next: () => {
      this.showPopup = false;
      this.loadCurrentKibor();
      this.loadKiborList();
    },
    error: err => console.error('Failed to save KIBOR', err)
  });
}


}
